const signMessage = (address) => {
  return `mixnoggle.xyz wants you to sign in with your Ethereum account:
${address}
  
Please ensure that the domain above matches the URL of the current website.`;
};
export { signMessage };
